import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit
} from '@angular/core';

import {
  Home,
  HomeContext,
  getSVGViewBox
} from '../assets';

@Component({
  selector: 'kyc-icon-home',
  template: Home.svg,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HomeComponent implements SVG2TSDynamic, OnInit {
  public static UUID = 0;
  public baseUrl: string;
  @Input() public height: number | string = Home.height;
  @Input() public viewBox: string = getSVGViewBox(Home.viewBox);
  @Input() public width: number | string = Home.width;
  @Input()
  public set context(ctx: HomeContext) {
    this.updateContext(ctx);
  }
  public get context() {
    return this._context;
  }

  private _context: HomeContext = Home.contextDefaults;

  constructor(private _ref: ChangeDetectorRef) {}


  public getURLBase(value: string) {
    return `url('${this.getXlinkBase(value)}')`;
  }

  public getXlinkBase(value: string) {
    return `${this.baseUrl}${value}`;
  }

  public ngOnInit() {
    this.baseUrl = window.location.href.replace(window.location.hash, '');
    this.context.uuid = HomeComponent.UUID++;
  }

  public updateContext(ctx: any) {
    this._context = Object.assign({}, this._context ? this._context : Home.contextDefaults, ctx);
    this._ref.markForCheck();
  }
}
